"use client";

import type { CSSProperties } from "react";
import { cn } from "@/lib/utils";

export default function TextWave({
  text,
  className,
}: {
  text: string;
  className?: string;
}) {
  const characters = Array.from(text);
  let waveIndex = 0;

  return (
    <span
      role="status"
      aria-label={text}
      className={cn(
        "planner-text-wave inline-flex min-w-0 flex-wrap items-baseline text-sm text-muted-foreground",
        className
      )}
    >
      <span className="sr-only">{text}</span>
      <span aria-hidden="true" className="inline-flex min-w-0 flex-wrap">
        {characters.map((character, index) => {
          const isWhitespace = /\s/.test(character);
          const style = isWhitespace
            ? undefined
            : ({
                "--planner-wave-index": waveIndex++,
              } as CSSProperties);

          return (
            <span
              key={`${index}:${character}`}
              className={isWhitespace ? "whitespace-pre" : "planner-wave-token"}
              style={style}
            >
              {character}
            </span>
          );
        })}
      </span>
    </span>
  );
}
